export const SAVED_ACCOUNTS_KEY = 'ac_saved_accounts';
